module.exports = __webpack_public_path__ + "static/img/about_dnn_2.de8985bb.png";